var React = require('react');

function Secuoyas (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 9A9 9 0 110 9a9 9 0 0118 0zm-7.047 4.635c-.014.134.067.201.2.201h1.726c.133 0 .2-.067.2-.2v-3.384c0-.134-.08-.2-.2-.2h-1.993c-.12 0-.2.066-.2.2v.227s-.268 1.244-1.806 1.244c-.575 0-.963-.308-.963-.709 0-1.177 4.975-.669 4.975-3.932 0-1.712-1.244-2.93-3.263-2.93-1.11 0-1.846.335-2.314.803l.053-.521c.014-.134-.067-.201-.2-.201H5.442c-.133 0-.2.067-.2.2v3.384c0 .134.08.201.2.201h1.993c.12 0 .2-.067.2-.2v-.215c0-.535.496-1.19 1.633-1.19.601 0 .95.254.95.669 0 1.458-5.297.722-5.297 4.012 0 1.405.95 2.836 3.29 2.836 1.779 0 2.742-.95 2.768-.95l-.026.655z","fill":"#fff"}));
}

Secuoyas.defaultProps = {"fill":"none","viewBox":"0 0 18 18"};

module.exports = Secuoyas;

Secuoyas.default = Secuoyas;
